import { ShopModule } from "../types/shopModuleTypes";
import { doApiGet, CallResult } from "./Requests";

export const shopModulesApi = {
  getEmployeeShopModules: async (): Promise<CallResult<ShopModule[]>> => {
    return await doApiGet<ShopModule[]>(`/api/employee/current/shopmodules`);
  },
};